export default __webpack_public_path__ + "static/media/list.d2c23f7b.svg";